import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { MarketplaceProfile } from "../../ApiCalls/Dashboard/MarketplaceAPI";

interface MarketplaceState {
  myProfile: MarketplaceProfile | null;
  profileLoaded: boolean;
  profileLoading: boolean;
}

const initialState: MarketplaceState = {
  myProfile: null,
  profileLoaded: false,
  profileLoading: false,
};

const marketplaceSlice = createSlice({
  name: "marketplace",
  initialState,
  reducers: {
    setMarketplaceProfile(state, action: PayloadAction<MarketplaceProfile | null>) {
      state.myProfile = action.payload;
      state.profileLoaded = true;
    },
    setProfileLoading(state, action: PayloadAction<boolean>) {
      state.profileLoading = action.payload;
    },
    clearMarketplaceProfile(state) {
      state.myProfile = null;
      state.profileLoaded = false;
    },
  },
});

export const { setMarketplaceProfile, setProfileLoading, clearMarketplaceProfile } =
  marketplaceSlice.actions;

export default marketplaceSlice.reducer;
